// NEW_FILE_JUSTIFIED: Plan summary card component — displays plan overview metrics matching .pen design
import { Badge } from '@/components/ui/badge';
import type { IPlanSummaryCardProps } from '@/@types/coverage';
import { formatCurrency } from '@/lib/coverage-utils';

export function PlanSummaryCard({
  planName,
  status,
  maxAnnualBenefit,
  annualDeductible,
  coinsurancePlanPays,
  coinsuranceYouPay,
  areaOfCoverage,
  currency,
}: IPlanSummaryCardProps) {
  return (
    <div className="rounded-xl border border-border bg-card">
      <div className="flex items-center justify-between px-6 py-5 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground">{planName}</h2>
        <Badge
          variant={status === 'active' ? 'default' : status === 'cancelled' ? 'destructive' : 'outline'}
          className="capitalize"
        >
          {status}
        </Badge>
      </div>

      <div className="grid grid-cols-4 divide-x divide-border px-6 py-5">
        <MetricColumn label="Max Annual Benefit" value={formatCurrency(maxAnnualBenefit, currency)} />
        <MetricColumn label="Annual Deductible" value={formatCurrency(annualDeductible, currency)} />
        <MetricColumn
          label="Coinsurance"
          value={`Plan ${coinsurancePlanPays}% / You ${coinsuranceYouPay}%`}
        />
        {areaOfCoverage && (
          <MetricColumn label="Area of Coverage" value={areaOfCoverage} />
        )}
      </div>
    </div>
  );
}

function MetricColumn({ label, value }: { label: string; value: string }) { // LOCAL_TYPE_JUSTIFIED: inline helper used only within PlanSummaryCard
  return (
    <div className="flex flex-col gap-1 px-6 first:pl-0">
      <span className="text-xs text-foreground-muted">{label}</span>
      <span className="text-[15px] font-semibold text-foreground">{value}</span>
    </div>
  );
}
